import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { MessageSquareText } from "lucide-react";
import { Req, SectionHeader, FieldError, invalidCls } from "@/components/newTicket/parts";
import { AttachmentPicker } from "@/components/Attachments";
import KbSuggesterPanel from "@/components/kb/KbSuggesterPanel";

export default function CustomerConcernSection({ form, setForm, mainName, subName, issueName, validation = {} }) {
  const concernErr = validation.err?.("customer_concern");
  return (
    <section data-testid="section-customer-concern">
      <SectionHeader
        letter="E" title="Customer Concern" icon={MessageSquareText}
        subtitle="Required · Captured at first contact"
      />
      <div className="grid grid-cols-1 lg:grid-cols-[1fr_180px] gap-5">
        <div>
          <Label className="text-xs font-semibold text-slate-700">Customer Concern<Req /></Label>
          <Textarea
            data-testid="customer-concern-input"
            rows={6}
            placeholder="Describe the concern in detail -- what happened, when, expected resolution, reference numbers..."
            className={`mt-1.5 resize-none ${invalidCls(concernErr)}`}
            value={form.customer_concern}
            onBlur={() => validation.touch?.("customer_concern")}
            onChange={(e) => setForm({ ...form, customer_concern: e.target.value })}
          />
          <p className="text-[11px] text-slate-500 mt-1.5">
            Min 20 characters <span className="text-slate-400 mx-1">·</span>
            {form.customer_concern.length}/20
            {form.customer_concern.length >= 20 && (
              <span className="text-indigo-600 ml-1">✓</span>
            )}
          </p>
          <FieldError name="customer_concern" msg={concernErr} />
          <div className="mt-2">
            <KbSuggesterPanel
              variant="inline"
              draft={{
                main_category: mainName || "",
                sub_category: subName || "",
                issue_type: issueName || "",
                q: form.customer_concern && form.customer_concern.length >= 12 ? form.customer_concern : "",
              }}
              limit={3}
            />
          </div>
        </div>
        <div>
          <Label className="text-xs font-semibold text-slate-700">Attachments</Label>
          <div className="mt-1.5 border border-dashed border-slate-300 bg-slate-50 rounded-lg p-4 text-center h-[calc(100%-1.75rem)] flex flex-col items-center justify-center gap-2 min-h-[156px]" data-testid="attachment-box">
            <AttachmentPicker
              value={form.attachment_ids}
              onChange={(ids) => setForm({ ...form, attachment_ids: ids })}
              compact
            />
            <p className="text-[10px] text-slate-500 mt-1">JPG · PNG · PDF</p>
          </div>
        </div>
      </div>
    </section>
  );
}
